import { useRouter } from 'next/router'
import { createContainer } from 'unstated-next'

import useSwr from '../../../../../hooks/use-swr'
import broadcastUtils from '../../../../../utils/broadcast'
import { broadcastRecommendationsParser } from '../utils/parser'

const BroadcastHomeStore = createContainer((initialData) => {
  const {
    query: { livdemyId, bcType, url, version },
    isFallback,
  } = useRouter()

  const { data, error, isValidating, revalidate } = useSwr({
    condition: !isFallback && Boolean(broadcastUtils.getByRoute(bcType)?.type),
    errorNotification: false,
    initialData: initialData?.info,
    server: 'public-cache',
    url: `broadcast-class/${
      broadcastUtils.getByRoute(bcType)?.type
    }/${livdemyId}/${url}/${version}`,
  })

  const masterclasses = useSwr({
    initialData: initialData?.masterclasses,
    parser: broadcastRecommendationsParser,
    server: 'public-cache',
    url: `broadcast-class/all/master-class`,
  })

  return {
    data: data || {},
    initialData,
    isValidating,
    loadFailed: Boolean(error) && !data,
    loading: !data,
    masterclasses,
    revalidate,
  }
})

export default BroadcastHomeStore
